import {useCallback, useEffect} from 'react'

import {throttle} from '@vio/core/src/utils/throttle'

type Props = {
  // The distance from the bottom of the page to detect in pixels
  distance?: number
  // The callback to call when the bottom of the page is detected
  onDetected: () => void
}

/**
 * Detects how far the user is from the bottom of the page
 */
const useDetectBottomOfPage = ({distance = 0, onDetected}: Props) => {
  const handleScroll = useCallback(() => {
    const {scrollTop, scrollHeight} = document.documentElement || {}
    const top = window.scrollY || scrollTop
    const userPosition = top + window.innerHeight
    const distanceToBottom = scrollHeight - userPosition

    if (distanceToBottom <= distance) onDetected()
  }, [distance, onDetected])

  const handleScrollThrottled = throttle(handleScroll, 500)

  useEffect(() => {
    window.addEventListener('scroll', handleScrollThrottled)
    return () => {
      window.removeEventListener('scroll', handleScrollThrottled)
    }
  }, [handleScrollThrottled])
}

export default useDetectBottomOfPage
